import CircularLoader from '../elements/progress/CircularLoader';

const OrgSwitchLoader = () => {
  const org_name = localStorage.getItem('nex_org_name') || 'Nexla';
  return (
    <div className="add-data-source-form connecting-mode-bg">
      <div className="connecting-mode">
        <div className="connecting-indicator">
          <CircularLoader size={308} thickness={20} style={{ marginTop: -3 }} />
        </div>
        <p className="connecting-message">Switching to {org_name}</p>
      </div>
    </div>
  );
};

export default OrgSwitchLoader;
